import { ApiBaseService, ApplicationsAPI } from './api.base.service';
import store from '@/store/store';
import { App, Application, SuccessResponse } from '../types';

export class ApplicationService {
  private api: ApiBaseService;

  constructor() {
    this.api = ApplicationsAPI;
  }

  public async getApplications(): Promise<any[]> {
    return this.api.get(`applications`);
  }

  public async getInstalledApplications(): Promise<any[]> {
    const organisationId = store.getters.activeOrganisation[0].id;
    return this.api.get(`applications/${organisationId}`);
  }

  public async createApplication(payload: any): Promise<App> {
    return this.api.post(`applications`, payload);
  }

  public async installApplication(id: string, version: string, projectId: number): Promise<void> {
    const organisation = store.getters.activeOrganisation[0];
    return this.api.post(`applications/${id}/${version}/${organisation.id}`, { project_id: projectId, organisation_slug: organisation.slug });
  }

  public async uninstallApplication(id: string, version: string, projectId: number): Promise<void> {
    const organisation = store.getters.activeOrganisation[0];
    return this.api.delete(`applications/${id}/${version}/${organisation.id}`, { project_id: projectId, organisation_slug: organisation.slug });
  }

  public async destroyApplication(id: string, version: string): Promise<void> {
    return this.api.delete(`applications/${id}/${version}`);
  }
}

export default new ApplicationService();
